import React from 'react';
import {useScript} from 'utils/hooks';


export default function Gumroad (){
    useScript('https://gumroad.com/js/gumroad.js');
    return (
      <a className="gumroad-button" href="https://gum.co/HWEJS">Choose your Price!</a>
    )
  }